export function header () {
    require('headroom.js')
    var header = document.querySelector('.header')
    var headroom = new Headroom(header)
    headroom.init()
}



/** WEBPACK FOOTER **
 ** ./assets/app/component/header/header.js
 **/